import { SelectProps } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { useColorModeValue } from '@chakra-ui/react';

type Props = {
  meta: FormInputMeta;
  [x: string]: any;
  register?: any;
  hasError?: any;
} & SelectProps;

export default function CustomInputSelect({ meta, register, hasError, ...rest }: Props) {
  const selectedOpt = meta.options && meta.options.find((opt) => opt.selected);
  const { name } = meta;
  const bg = useColorModeValue('white', 'gray.800')
  return (
    <>
      
      {register ? <CC.Select
        {...rest}
        {...register}
        bg={bg}
        // defaultValue={selectedOpt ? selectedOpt.value : ''}
        placeholder={"Please select a value"}
      >
        {/* <option value="">Please select a value</option> */}
        {meta.options &&
          meta.options.map((opt, i) => (
            <option key={i} value={opt.value}>
              {opt.label}
            </option>
          ))}
      </CC.Select> : <CC.Select
        {...rest}
        name={name}
        bg={bg}
        defaultValue={selectedOpt ? selectedOpt.value : ''}
        placeholder={"Please select a value"}
      >
        {/* <option value="">Please select a value</option> */}
        {meta.options &&
          meta.options.map((opt, i) => (
            <option key={i} value={opt.value}>
              {opt.label}
            </option>
          ))}
      </CC.Select>}
      {name && hasError && <CC.FormErrorMessage>{hasError.message}</CC.FormErrorMessage>}
    </>
  );
}